import Editorical_notes from './editorical_notes';


export default Editorical_notes;

export {
    Editorical_notes
}